import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { SubmitMcafRequestPayload } from '@shared/services/financialConsent/types/submitMcaf.types';
import type { SubmitNefrRequestPayload } from '@shared/services/financialConsent/types/submitNefr.types';

import { initialState } from './initialState';

const fcSlice = createSlice({
  initialState,
  name: 'FinancialConsents',
  reducers: {
    resetDataValues: (state) => {
      state.data = initialState.data;
    },
    resetMCAFValues: (state) => {
      state.mcaf = initialState.mcaf;
    },
    setDataValues: (state, action: PayloadAction<SubmitNefrRequestPayload>) => {
      state.data = action.payload;
    },
    setMCAFValues: (state, action: PayloadAction<SubmitMcafRequestPayload>) => {
      state.mcaf = action.payload;
    },
  },
});

export const { actions: fcAction } = fcSlice;

export default fcSlice.reducer;
